import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=0c2423ef"
import script from "./ProfilePreview.vue?vue&type=script&lang=js"
export * from "./ProfilePreview.vue?vue&type=script&lang=js"
import style0 from "./ProfilePreview.vue?vue&type=style&index=0&id=0c2423ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports